const maskSSN = (ssn) => {
    const masked = ssn.slice(0, 7).replace(/[0-9]/g, "*");
    return masked + ssn.slice(7);
};

export default maskSSN;
